import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { getSortState, JhiItemCount, JhiPagination } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table, Tag, Space, Button, Row, Form, Spin } from 'antd';
import { getEleves, resetSearchCriteria, setLastListPage } from './eleve.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { getClasses } from '../classe/classe.reducer';
import { getSession } from 'app/shared/reducers/authentication';
import EleveHeader from './EleveHeader';

export const Eleve = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();
  const [file, setFile] = useState(null);
  const [_uploading, setUploading] = useState(false);
  const [_loadingList, setLoadingList] = useState(false);
  const [_apiUrl, setApiUrl] = useState(`/api/eleves/download?ecoleId=${props.match.params.ecoleid}`);
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const totalItems = useAppSelector(state => state.eleve.totalItems);
  const eleveList = useAppSelector(state => state.eleve.entities);
  const loading = useAppSelector(state => state.eleve.loading);
  const searchCriteria = useAppSelector(state => state.eleve.searchCriteria);
  const lastListPage = useAppSelector(state => state.eleve.lastListPage);

  const buildPageSearch = (page: number) => {
    const params = new URLSearchParams(props.location.search);
    if (page > 1) {
      params.set('page', `${page}`);
    } else {
      params.delete('page');
    }
    return params.toString() ? `?${params.toString()}` : '';
  };
  const currentListSearch = buildPageSearch(paginationState.activePage);

  useEffect(() => {
    const shouldReuseCriteria = !lastListPage || lastListPage === 'eleve';
    if (lastListPage && lastListPage !== 'eleve') {
      dispatch(resetSearchCriteria());
    }
    dispatch(setLastListPage('eleve'));

    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getClasses(props.match.params.ecoleid));

    const initialEntity = {
      ...(shouldReuseCriteria ? searchCriteria : {}),
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getEleves(initialEntity));
  }, []);

  const prop = {
    onRemove() {
      setFile(null);
      setUploading(false);
    },
    beforeUpload(fil) {
      setFile(fil);
      return false;
    },
    file,
  };

  const eleveListe = () => {
    const entity = {
      ...searchCriteria,

      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getEleves(entity));
  };
  const sortEntities = () => {
    eleveListe();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}`);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const nextPage = page ? +page : 1;
    setPaginationState(prev => (prev.activePage === nextPage ? prev : { ...prev, activePage: nextPage }));
  }, [props.location.search]);

  const handlePagination = currentPage => {
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
    const nextSearch = buildPageSearch(currentPage);
    if (props.location.search !== nextSearch) {
      props.history.push({
        pathname: props.location.pathname,
        search: nextSearch,
      });
    }
    const entity = {
      ...searchCriteria,
      anneeScolaireId: props.match.params.anneeScolaireId,
      ecoleId: props.match.params.ecoleid,
      page: currentPage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getEleves(entity));
  };

  const onSearch = val => {
    const entity = {
      ...searchCriteria,
      ...val,
      anneeScolaireId: props.match.params.anneeScolaireId,
      ecoleId: props.match.params.ecoleid,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getEleves(entity));
    let etatPaiement;
    let statutPresence;
    let matricule;
    let nom, prenom;
    let classe;
    let searchUrl = '';
    if (entity.matricule) {
      matricule = '&matricule=' + entity.matricule;
      searchUrl += matricule;
    }
    if (entity.nom) {
      nom = '&nom=' + entity.nom;
      searchUrl += nom;
    }
    if (entity.prenom) {
      prenom = '&prenom=' + entity.prenom;
      searchUrl += prenom;
    }
    if (entity.classe) {
      classe = '&classe=' + entity.classe;
      searchUrl += classe;
    }
    if (entity.etatPaiement) {
      etatPaiement = '&etatPaiement=' + entity.etatPaiement;
      searchUrl += etatPaiement;
    }
    if (entity.statutPresence) {
      statutPresence = '&statutPresence=' + entity.statutPresence;
      searchUrl += statutPresence;
    }
    if (!entity.matricule && !entity.nom && !entity.prenom && !entity.classe && !entity.etatPaiement && !entity.statutPresence) {
      setApiUrl(`/api/eleves/download?ecoleId=${entity.ecoleId}`);
    } else {
      setApiUrl(`/api/eleves/download?ecoleId=${entity.ecoleId}${searchUrl ? '' : '?'}${searchUrl}`);
    }
  };

  const columns = [
    {
      title: 'Matricule',
      dataIndex: 'matricule',
      key: 'matricule',
    },
    {
      title: 'Prénoms',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'Classe',
      dataIndex: 'classe',
      key: 'classe',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => (status === 'PRESENT' ? <Tag color="green">{status}</Tag> : <Tag color="red">{status}</Tag>),
    },
    {
      title: 'Etat',
      dataIndex: 'etat',
      key: 'etat',
      render: etat => (etat === 'A_JOUR' ? <Tag color="green">{etat}</Tag> : <Tag color="red">{etat}</Tag>),
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link
              to={{
                pathname: `${match.url}/${id}/details`,
                search: currentListSearch,
              }}
            >
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  const data = eleveList
    .map((eleve, i) => ({
      id: eleve.id,
      nom: eleve?.lastName ?? 'Nom inconnu',
      prenom: eleve?.firstName ?? 'Prénom inconnu',
      classe: eleve?.classe?.nom ?? 'Classe inconnue',
      matricule: eleve?.matricule ?? 'Matricule inconnu',
      status: eleve?.statutPresence ?? 'Inconnu',
      etat: eleve?.etatPaiement ?? 'Etat inconnu',
    }))
    .reverse();
  const { match } = props;

  return (
    <div>
      <EleveHeader
        ecoleId={props.match.params.ecoleid}
        anneeScolaireId={props.match.params.anneeScolaireId}
        paginationState={paginationState}
      />

      <Form name="basic" layout="inline" onFinish={onSearch}>
        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Table columns={columns} dataSource={data.reverse()} pagination={false} />
          </Spin>
        </div>

        {totalItems ? (
          <div className={eleveList && eleveList.length > 0 ? 'table-responsive' : 'd-none'}>
            <Row className="justify-content-center">
              <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
            </Row>
            <Row className="justify-content-center">
              <JhiPagination
                activePage={paginationState.activePage}
                onSelect={handlePagination}
                maxButtons={5}
                itemsPerPage={paginationState.itemsPerPage}
                totalItems={totalItems}
              />
            </Row>
          </div>
        ) : (
          ''
        )}
      </Form>
    </div>
  );
};

export default Eleve;
